var projcontainerCustomFieldList = '', projcontainerContactFields = [], lastProjContainerCustomField = '';
var tbProjContainer = null;

function DisableProjContainerFields() {
	jQuery('select,input,textarea', 'div.projcontainer-home-table-column').prop('disabled', 'true').css("background-color", 'lightgray').removeClass('required');
	jQuery('div.pjq-multiple-choice-list', 'div.projcontainer-home-table-column').css("background-color", 'lightgray');
	jQuery('img.ui-datepicker-trigger', 'div.projcontainer-home-table-column').addClass('pjq-hidden');
}

function DetachProjContainer() {
	PanteraScript.PanteraScriptService.DetachProjectContainer(pjqSessionId, DetachPCC, onScriptError);
}

function DetachPCC() {
	jQuery('#projcontainer-home').html("<div><img src='/i/ajax-loader.gif' alt='Loading...' style='vertical-align: middle;' /><span style='font-weight: bold;vertical-align: middle; padding-left: 6px;'>Reloading...</span></div>");
	PanteraScript.PanteraScriptService.GetProjectContainerInfo(pjqSessionId, ProjContainerInfoC, onScriptError);
}

function PJQProjectWallAdminProjContainerInitialize() {
	if (google && pjqWallContext == 'projcontainer') {
		geocoder = new google.maps.Geocoder();
		myLatLng = new google.maps.LatLng(42.8282, -98.5795);
		mapOptions = {
			zoom: 15,
			center: myLatLng,
			mapTypeId: google.maps.MapTypeId.SATELLITE
		}
	}

	if (pjqWallContext == 'project') {
		tbProjContainer = new dhtmlXToolbarObject("projcontainer-tb");
		tbProjContainer.setSkin("dhx_web");
		tbProjContainer.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		tbProjContainer.addButton("select_projcontainer", 1, 'Select ' + settings.ProjContainerLabel, "", "");
		tbProjContainer.addSeparator("sep2", 3);
		tbProjContainer.addButton("disconnect_projcontainer", 3, 'Detach ' + settings.ProjContainerLabel, "", "");

		if (projContainer.ProjectContainerId == 0) {
			tbProjContainer.disableItem("disconnect_projcontainer");
			DisableProjContainerFields();
		}

		tbProjContainer.attachEvent("onClick", function (id) {
			if (id == 'select_projcontainer') {
				var url = '/Default.aspx?tabId=' + settings.ProjectContainerTabId.toString() + '&spc=' + pjqSessionId + '&v=' + gridITBGroupBy;
				window.location.href = url;
			}
			else if (id == 'disconnect_projcontainer') {
				showInfoDialogPWall('Detach ' + settings.ProjContainerLabel, 'Are you sure you want to detach the ' + settings.ProjContainerLabel + ' from this Project?', 'ui-icon-alert', 'detach-projcontainer');

			}
		});

	}
	else
		jQuery('#projcontainer-tb').addClass('pjq-hidden');

	jQuery('td.pjq-projcontainer-user-1-label').html('<b>' + settings.ProjContainerUser1Label + '</b>');
	jQuery('td.pjq-projcontainer-user-2-label').html('<b>' + settings.ProjContainerUser2Label + '</b>');
	if (settings.ProjectUser2Hidden)
		jQuery("td.pjq-projcontainer-user-2-label, td.pjq-projcontainer-user-2-value").addClass('pjq-hidden');

	if (projContainer.Country == 'CA') {
		jQuery("#projcontainer-zip").mask('a9a 9a9', {placeholder: " "});
		jQuery('#projcontainer-state-us').addClass('pjq-hidden');
		jQuery('#projcontainer-state-ca').removeClass('pjq-hidden');
		jQuery('#projcontainer-zip').removeClass('zipcodeUS');
		jQuery('#projcontainer-zip').addClass('zipcodeCA');
		jQuery('#projcontainer-state-ca').focus();
	}
	else {
		jQuery("#projcontainer-zip").mask('99999', {placeholder: " "});
		jQuery('#projcontainer-state-ca').addClass('pjq-hidden');
		jQuery('#projcontainer-state-us').removeClass('pjq-hidden');
		jQuery('#projcontainer-state-us').focus();
		jQuery('#projcontainer-zip').addClass('zipcodeUS');
		jQuery('#projcontainer-zip').removeClass('zipcodeCA');
	}

	var i = 0;
	var optionList = '';
	var userOpts = Array();
	for (i = 0; i < settings.CompanyUsers.length; i++) {
		optionList = optionList + "<option value='" + settings.CompanyUsers[i].UserId.toString() + "'>" + settings.CompanyUsers[i].ContactName + "</option>";
	}
	jQuery('#projcontainer-user-1').append(optionList).val(projContainer.UserId.toString());
	jQuery('#projcontainer-user-2').append("<option value=''>Select...</option>" + optionList).addClass('pjq-hidden');
	jQuery('td.pjq-projcontainer-user-2-label').addClass('pjq-hidden');
	/*
	if (projContainer.User2Id)
	  jQuery('#projcontainer-user-2').val(projContainer.User2Id.toString());
	*/

	jQuery('td.pjq-projectcontainer-name').text(settings.ProjContainerLabel);
}

function ProjContainerCustomFieldsInitialize() {
	projcontainerContactFields = [];

	jQuery('div.pjq-projcontainer-custom-field').remove();
	var i = 0;
	var template = '';
	for (i = 0; i < projContainerCustomFields.length; i++) {
		template = '';
		template += "<div class='projcontainer-home-table-column pjq-projcontainer-custom-field{{if FieldType == 'CONTACT'}} pjq-contact-field-column{{else FieldType == 'CHOICE' && IsChoiceListMultipleChoice}} pjq-multiple-choice-column{{/if}}'>";
		template += "  <table class='pjq-editable-table' >";
		template += "     <tr>";
		template += "	    <td class='pjq-field-label project-home-table-label'>{{>FieldName}}</td>";
		template += "      {{if IsRequired}}<td class='pjq-label-required' style='width: 8px;'>*</td>{{else}}<td style='width: 8px;'>&nbsp;</td>{{/if}}";
		template += "      <td class='pjq-field-value'>";

		template += "{{if FieldType == 'TEXT'}}";
		template += "       <input id='projcontainer-custom-{{attr:ProjectCustomFieldId}}' type='text' class='pjq-default-field-width{{if IsRequired}} required{{/if}}' value='{{attr:FieldValue}}' maxlength='4000' onchange='EnableSaveP();' onkeydown='return EnableSaveP();' />";
		template += "{{else FieldType == 'INT'}}";
		template += "         <input id='projcontainer-custom-{{attr:ProjectCustomFieldId}}' type='text' class='pjq-numeric-field-width integer{{if IsRequired}} required{{/if}}' value='{{attr:FieldValue}}' maxlength='10'{{if NumericMinValue > 0}} min='{{attr:NumericMinValue}}'{{/if}}{{if NumericMaxValue > 0}}  max='{{attr:NumericMaxValue}}'{{/if}} onchange='EnableSaveP();' onkeydown='return EnableSaveP();' />";
		template += "{{else FieldType == 'DATE'}}";
		template += "         <input id='projcontainer-custom-{{attr:ProjectCustomFieldId}}' type='text' class='pjq-date-field-width{{if IsRequired}} date required{{else}} dateOPT{{/if}}' value='{{>~parseDate(FieldValue)}}' maxlength='10' onkeydown='return EnableSaveP();' />";
		template += "{{else FieldType == 'DATETIME'}}";
		template += "         <input id='projcontainer-custom-{{attr:ProjectCustomFieldId}}' type='text' class='pjq-date-field-width{{if IsRequired}} date required{{else}} dateOPT{{/if}}' value='{{>~parseDateDT(FieldValue)}}' maxlength='10' onkeydown='return EnableSaveP();' />&nbsp;&nbsp;<input id='projcontainer-custom2-{{attr:ProjectCustomFieldId}}' type='text' class='pjq-time-field-width {{if IsRequired}} time12h required{{else}} time12hOPT{{/if}}' value='{{>~parseTimeDT(FieldValue)}}' maxlength='8' onkeydown='return EnableSaveP();' /><img id='projcontainer-custom2-tp-{{attr:ProjectCustomFieldId}}' class='ui-timepicker-trigger' src='/i/icon_scheduler_16px.gif' alt='...' title='...'>";
		template += "{{else FieldType == 'BOOL'}}";
		template += "         <select id='projcontainer-custom-{{attr:ProjectCustomFieldId}}' class='pjq-bool-field-width{{if IsRequired}} selectREQ{{/if}}' onchange='EnableSaveP();'>";
		template += "          <option value=''>Select Answer...</option>";
		template += "          <option value='true'{{if FieldValue == 'true' || FieldValue == 'Yes'}} selected='selected'{{/if}}>Yes</option>";
		template += "          <option value='false'{{if FieldValue == 'false' || FieldValue == 'No'}} selected='selected'{{/if}}>No</option>";
		template += "         </select>";
		template += "{{else FieldType == 'CHOICE'}}";
		template += " {{if IsChoiceListMultipleChoice}}";
		template += "          <div id='projcontainer-custom-{{attr:ProjectCustomFieldId}}' class='pjq-choice-field-width pjq-multiple-choice-list {{if IsRequired}} pjq-required{{/if}}'  data-choice-list='{{attr:FieldValue}}'>";
		template += " {{for ChoiceList ~ProjectCustomFieldId=ProjectCustomFieldId}}";
		template += "		   <input type='checkbox' id='projcontainer-custom-{{>~ProjectCustomFieldId}}_{{attr:ChoiceId}}' value='{{attr:ChoiceId}}' choice-name='{{attr:ChoiceName}}' onchange='EnableSaveP();' />";
		template += "           <label for='myCustom_{{attr:ProjectCustomFieldId}}_{{attr:ChoiceId}}'>{{>ChoiceName}}</label><br />";
		template += " {{/for}}";
		template += "		  </div>";
		template += " {{else}}";
		template += "          <select id='projcontainer-custom-{{attr:ProjectCustomFieldId}}' class='pjq-choice-field-width{{if IsRequired}} selectREQ{{/if}}' data-choice-list='{{attr:FieldValue}}' onchange='EnableSaveP();'>";
		template += "          <option value=''>Select...</option>";
		template += " {{for ChoiceList}}";
		template += "           <option value='{{attr:ChoiceId}}' text='{{attr:ChoiceName}}'>{{>ChoiceName}}</option>";
		template += " {{/for}}";
		template += "          </select>";
		template += " {{/if}}";
		template += "{{else FieldType == 'CONTACT'}}";
		template += "  <div id='projcontainer-custom-{{attr:ProjectCustomFieldId}}' class='pjq-contact-field-width{{if IsRequired}} selectREQ{{/if}}{{if IsChoiceListMultipleChoice}} pjq-multiple-contact-list{{/if}}'><div id='pjq-contact-tb-{{attr:ProjectCustomFieldId}}' class='pjq-contact-toolbar'></div><div id='pjq-contact-grid-{{attr:ProjectCustomFieldId}}' class='pjq-contact-grid'></div></div>";
		template += "{{/if}}";


		template += "      </td></tr>";
		template += "  </table>";
		template += "</div>";
		var pcfTemplate = $.templates(template);

		jQuery('#projcontainer-custom-fields-loading').before(pcfTemplate.render(projContainerCustomFields[i]));
	}
	jQuery('#projcontainer-custom-fields-loading').text('');

	jQuery("input.pjq-date-field-width", jQuery('div.pjq-projcontainer-custom-field')).each(function () {
		if (!jQuery(this).hasClass('hasDatepicker')) {
			jQuery(this).mask('99/99/9999', {placeholder: " "});
			jQuery(this).datepicker({
				showOn: "button",
				numberOfMonths: 3,
				showButtonPanel: true,
				buttonImage: "/i/calendar.png",
				buttonImageOnly: true,
				onSelect: ValidateDateHelper
			});
		}
	});
	jQuery("div.pjq-projcontainer-custom-field input.pjq-time-field-width").each(function () {
		jQuery(this).mask('99:99 am', {placeholder: " "});
		var fieldId = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('-') + 1);

		jQuery(this).timepicker({
			showOn: 'button',
			showPeriod: true,
			button: '#projcontainer-custom2-tp-' + fieldId
		});

	});


	jQuery("input.pjq-numeric-field-width", jQuery('div.pjq-projcontainer-custom-field')).each(function () {
		var minVal = 0;
		if (jQuery(this).attr('min'))
			minVal = parseInt(jQuery(this).attr('min'));
		var maxVal = 2147483647;
		if (jQuery(this).attr('max'))
			maxVal = parseInt(jQuery(this).attr('max'));
		jQuery(this).spinner({
			min: minVal, max: maxVal, step: 1, spin: function (event, ui) {
				EnableSaveP();
			}
		});
	});

	jQuery("select.pjq-choice-field-width", jQuery('div.pjq-projcontainer-custom-field')).each(function () {
		var x = jQuery(this).attr('data-choice-list').split('|||');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("option[text='" + x[i].trim() + "']").attr('selected', 'selected');
		}
	});
	jQuery("div.pjq-multiple-choice-list", jQuery('div.pjq-projcontainer-custom-field')).each(function () {
		var x = jQuery(this).attr('data-choice-list').split(',');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("input[choice-name='" + x[i].trim() + "']").attr('checked', 'checked');
		}
	});
	jQuery("div.pjq-contact-field-width", jQuery('div.pjq-projcontainer-custom-field')).each(function () {
		var id = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('-') + 1);
		var tbDiv = jQuery('div.pjq-contact-toolbar', jQuery(this));
		var tbContact = new dhtmlXToolbarObject(tbDiv.attr('id'));
		tbContact.setSkin("dhx_web");
		tbContact.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		tbContact.addButton("add", 1, "Add Contact", "addcontact.png", "addcontactD.png");
		tbContact.disableItem("add");
		tbContact.addSeparator("sep1", 2);
		tbContact.addButton("edit", 3, "Contact Details", "worker.png", "workerD.png");
		tbContact.disableItem("edit");
		tbContact.addSeparator("sep2", 4);
		tbContact.addSpacer("sep2");
		tbContact.addSeparator("sep3", 5);
		tbContact.addButton("delete", 6, "Delete Contact", "action_delete.gif", "action_deleteD.gif");
		tbContact.disableItem("delete");
		tbContact.attachEvent("onClick", function (id) {
			lastProjContainerCustomField = jQuery(this.cont).attr('id');
			lastProjContainerCustomField = lastProjContainerCustomField.substring(lastProjContainerCustomField.lastIndexOf('-') + 1);
			if (id == 'add') {
				if (!SaveProjContainer())
					return;

				setTimeout(function () {
					var url = '/Default.aspx?tabId=' + settings.AddressBookTabId.toString() + '&pccf=' + pjqSessionId + '&pccfid=' + lastProjContainerCustomField;
					if(PJQ.app.module !== PJQ.constants.modules.PROJECTWALLADMIN){
						url += '&src=p';
					}
					window.location.href = url;
				}, 500);
			}
			else if (id == 'edit') {
				EditContactPCCF();
			}
			else if (id == 'delete') {
				showInfoDialogPWall('Delete Contact', 'Are you sure you want to delete this Contact from the ' + settings.ProjContainerLabel + '?', 'ui-icon-alert', 'delete-contacts-pccf');
			}
		});
		if (projContainer.ProjectContainerId == 0) {
			tbContact.disableItem('add');
		}
		var cmContact = new dhtmlXMenuObject();
		cmContact.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
		cmContact.addNewChild(cmContact.topId, 0, "edit", "Contact Details", false, "worker.png");
		cmContact.addNewChild(cmContact.topId, 1, "delete", "Delete Contact", false, "action_delete.gif");
		cmContact.setUserData("edit", "ProjectContainerCustomFieldId", id);
		cmContact.setUserData("delete", "ProjectContainerCustomFieldId", id);
		cmContact.renderAsContextMenu();
		cmContact.attachEvent("onClick", function (id, zoneId, casState) {
			lastProjContainerCustomField = cmContact.getUserData("edit", "ProjectContainerCustomFieldId");
			if (id == 'edit') {
				EditContactPCCF();
			}
			else if (id == 'delete') {
				showInfoDialogPWall('Delete Contact', 'Are you sure you want to delete this Contact from the ' + settings.ProjContainerLabel + '?', 'ui-icon-alert', 'delete-contacts-pccf');
			}
		});


		var gDiv = jQuery('div.pjq-contact-grid', jQuery(this));
		var gridContact = new dhtmlXGridObject(gDiv.attr('id'));
		gridContact.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');//path to images required by grid
		gridContact.enableMultiline(true);
		gridContact.setSkin(pjqGridTheme);
		gridContact.setNoHeader(true);
		gDiv.css('width', '99%');
		gridContact.init();
		dhtmlxEvent(window, "resize", function () {
			gDiv.css('width', '99%');
			this.setSizes();
		});
		gridContact.enableAutoHeight(true);

		gridContact.enableContextMenu(cmContact);
		gridContact.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
			obj.selectRowById(id);
			return true;
		});

		gridContact.attachEvent("onRowSelect", function (rId) {
			this.setSelectedRow(rId);
			var id = gDiv.attr('id').substring(gDiv.attr('id').lastIndexOf('-') + 1);
			var i = 0;
			for (i = 0; i < projcontainerContactFields.length; i++) {
				if (projcontainerContactFields[i][0] == id) {
					var tb = projcontainerContactFields[i][1];
					tb.enableItem("edit");
					tb.enableItem("delete");
				}
			}

			return true;
		})

		projcontainerContactFields.push(new Array(id, tbContact, gridContact, cmContact));

		gridContact.loadXML('/DesktopModules/PJQProjectWallAdmin/GetPCCFContacts.aspx?id=' + id + '&sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), function () {
			var id = gDiv.attr('id').substring(gDiv.attr('id').lastIndexOf('-') + 1);
			var i = 0;
			for (i = 0; i < projcontainerContactFields.length; i++) {
				if (projcontainerContactFields[i][0] == id) {
					var grid = projcontainerContactFields[i][2];
					var tb = projcontainerContactFields[i][1];
					if (grid.getRowsNum() == 0) {
						var msg = 'No Contact Selected';
						if (pjqIsNewProjContainer)
							msg += ' - Save ' + settings.ProjContainerLabel + ' before adding a Contact';

						gDiv.prepend("<div style='padding: 4px; background-color: white;'>" + msg.replace('"', '') + "</div>");
						gDiv.css('height', '24px');

						if (projContainer.ProjectContainerId > 0)
							tb.enableItem("add");
					}
					else {
						if (gDiv.parent().hasClass('pjq-multiple-contact-list') && projContainer.ProjectContainerId > 0)
							tb.enableItem("add");
					}
				}
			}

		});

	});

	if (projContainer.ProjectContainerId == 0 && pjqWallContext == 'project') {
		DisableProjContainerFields();
	}

}

function EditContactPCCF() {
	var i = 0;
	for (i = 0; i < projcontainerContactFields.length; i++) {
		if (projcontainerContactFields[i][0] == lastProjContainerCustomField) {
			var grid = projcontainerContactFields[i][2];
			var id = grid.getSelectedRowId();
			PanteraScript.PanteraScriptService.GetContactInfoAdmin(pjqSessionId, parseInt(id), EditContactPCCFC, onScriptError);
			break;
		}
	}
}

function EditContactPCCFC(response) {
	var contact = jQuery.parseJSON(response);
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'EditContact', {
		isOldModule: PJQ.app == null || PJQ.app.module !== PJQ.constants.modules.APP,
		isJsRender: true
	}), $('#dialog-edit-contact'), contact, function () {
		if (typeof PJQProjectWallAdminEditContactInitialize == 'function')
			PJQProjectWallAdminEditContactInitialize(contact);

		var buttonList = {
			"Save Changes": function () {
				myInfoSave('pccf');
			}
		};

		if (settings.IsAddressBookRO)
			buttonList = {};

		var dlg = jQuery("#dialog-edit-contact").dialog({
			resizable: false,
			height: 600,
			width: 800,
			title: 'Contact Details',
			modal: true,
			draggable: false,
			buttons: buttonList

		});
		dlg.parent().appendTo($("Form[name='Form']"));
	});
}

function EditContactPCCFCC() {
	var i = 0;
	for (i = 0; i < projcontainerContactFields.length; i++) {
		if (projcontainerContactFields[i][0] == lastProjContainerCustomField) {
			var grid = projcontainerContactFields[i][2];
			var id = grid.getSelectedRowId();
			PanteraScript.PanteraScriptService.GetContactInfo(pjqSessionId, 'c', id, EditContactPCCFCCC, onScriptError);
		}
	}
}

function EditContactPCCFCCC(response) {
	var contactInfo = jQuery.parseJSON(response);
	var i = 0;
	for (i = 0; i < projcontainerContactFields.length; i++) {
		if (projcontainerContactFields[i][0] == lastProjContainerCustomField) {
			var grid = projcontainerContactFields[i][2];
			var tb = projcontainerContactFields[i][1];
			grid.cells(grid.getSelectedRowId(), 0).setValue(contactInfo.ContactData);
			grid.cells(grid.getSelectedRowId(), 1).setValue(contactInfo.GroupList);
			tb.enableItem("edit");
			tb.enableItem("delete");
		}
	}
}

function DeleteContactPCCF() {
	var i = 0;
	for (i = 0; i < projcontainerContactFields.length; i++) {
		if (projcontainerContactFields[i][0] == lastProjContainerCustomField) {
			var container = '#projcontainer-custom-' + lastProjContainerCustomField;
			var tb = projcontainerContactFields[i][1];
			var grid = projcontainerContactFields[i][2];
			var idToDelete = grid.getSelectedRowId();
			grid.clearSelection();
			grid.deleteRow(idToDelete);
			tb.disableItem("edit");
			tb.disableItem("delete");
			if (!jQuery(container).hasClass('pjq-multiple-contact-list')) {
				tb.enableItem("add");
				var msg = 'No Contact Selected';

				jQuery('div.pjq-contact-grid', jQuery(container)).prepend("<div style='padding: 4px; background-color: white;'>" + msg.replace('"', '') + "</div>").css('height', '24px');
			}

			EnableSaveP();
			break;
		}
	}
}

function SaveProjContainer() {
	// validate all fields
	var errElem = null;

	// validate project core fields
	// if (!validator.element('#projcontainer-name'))
	// 	errElem = jQuery('#projcontainer-name');
	//
	// if (!validator.element('#projcontainer-address1'))
	// 	errElem = jQuery('#projcontainer-address1');
	//
	// if (!validator.element('#projcontainer-address2'))
	// 	errElem = jQuery('#projcontainer-address2');
	//
	// if (!validator.element('#projcontainer-city'))
	// 	errElem = jQuery('#projcontainer-city');
	//
	// if (!validator.element('#projcontainer-zip'))
	// 	errElem = jQuery('#projcontainer-zip');


	// validate project custom fields
	jQuery('div.pjq-projcontainer-custom-field tbody tr td input.required,div.pjq-projcontainer-custom-field tbody tr td input.date, div.pjq-projcontainer-custom-field tbody tr td span input.required, div.pjq-projcontainer-custom-field tbody tr td select.selectREQ, div.pjq-projcontainer-custom-field tbody tr td div.pjq-required').each(function () {
		var hasError = false;

		if (jQuery(this).attr('class').indexOf('dhxtoolbar') > -1 || jQuery(this).attr('class').indexOf('dhx_toolbar') > -1)
			return;

		if (jQuery(this).prop("tagName") == 'DIV' && jQuery(this).hasClass('pjq-required') && jQuery(this).hasClass('pjq-multiple-choice-column')) {
			if (jQuery("input[type='checkbox']:checked", this).length == 0) {
				hasError = true;
				jQuery(this).parent().append("<label for='" + jQuery(this).prop('id') + "' class='pjq-errortext'>Please check at least one selection.</label>");
				jQuery(this).addClass('pjq-errortext');
				errElem = jQuery(this);
			}
			else {
				jQuery(this).removeClass('pjq-errortext');
				jQuery(this).parent().find('label.pjq-errortext').remove();
			}

		}
		// else if (!validator.element(this)) {
		// 	errElem = jQuery(this);
		// }
	});

	// if there's an error, set focus to the first bad field
	if (null != errElem) {
		errElem.focus();
		return false;
	}

	// save project container core fields
	// save project container custom fields

	var stateProvince = jQuery('#projcontainer-state-us').val();
	if (!stateProvince)
		stateProvince = jQuery('#projcontainer-state-ca').val();

	projcontainerCustomFieldList = '';
	jQuery("div.pjq-projcontainer-custom-field tbody tr td input[type='text'],div.pjq-projcontainer-custom-field tbody tr td input.date, div.pjq-projcontainer-custom-field tbody tr td span input, div.pjq-projcontainer-custom-field tbody tr td select, div.pjq-projcontainer-custom-field tbody tr td div.pjq-multiple-choice-list, div.pjq-projcontainer-custom-field tbody tr td div.pjq-contact-field-width").each(function () {

		if (jQuery(this).hasClass('pjq-time-field-width'))
			return;

		if (jQuery(this).attr('class').indexOf('dhxtoolbar') > -1 || jQuery(this).attr('class').indexOf('dhx_toolbar') > -1)
			return;

		var fieldId = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('-') + 1);
		if (jQuery(this).hasClass('pjq-contact-field-width')) {
			var id = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('-') + 1);
			var i = 0;
			for (i = 0; i < projcontainerContactFields.length; i++) {
				if (projcontainerContactFields[i][0] == id) {
					var grid = projcontainerContactFields[i][2];
					projcontainerCustomFieldList = projcontainerCustomFieldList + fieldId + '{|}' + grid.getAllRowIds() + '||||';
				}
			}
		}
		else if (jQuery(this).prop('tagName') == 'SELECT') {
			projcontainerCustomFieldList = projcontainerCustomFieldList + fieldId + '{|}';
			jQuery('option:selected', jQuery(this)).each(function () {
				projcontainerCustomFieldList = projcontainerCustomFieldList + jQuery(this).val() + ',';
			});
			if (projcontainerCustomFieldList.substring(projcontainerCustomFieldList.length - 1) == ',')
				projcontainerCustomFieldList = projcontainerCustomFieldList.substring(0, projcontainerCustomFieldList.length - 1);
			projcontainerCustomFieldList = projcontainerCustomFieldList + '||||';
		}
		else if (jQuery(this).prop("tagName") == 'DIV') {
			projcontainerCustomFieldList = projcontainerCustomFieldList + fieldId + '{|}';
			jQuery("input[type='checkbox']:checked", this).each(function () {
				projcontainerCustomFieldList = projcontainerCustomFieldList + jQuery(this).val() + ',';
			});
			if (projcontainerCustomFieldList.substring(projcontainerCustomFieldList.length - 1) == ',')
				projcontainerCustomFieldList = projcontainerCustomFieldList.substring(0, projcontainerCustomFieldList.length - 1);

			projcontainerCustomFieldList = projcontainerCustomFieldList + '||||';
		}
		else if (jQuery(this).hasClass('pjq-date-field-width')) {
			var dt = jQuery(this).val();
			if (jQuery('#project-custom2-' + fieldId).length > 0)
				dt += ' ' + jQuery('#project-custom2-' + fieldId).val();
			projcontainerCustomFieldList = projcontainerCustomFieldList + fieldId + '{|}' + dt.trim() + '||||';
		}
		else {
			projcontainerCustomFieldList = projcontainerCustomFieldList + fieldId + '{|}' + jQuery(this).val() + '||||';
		}
	});
	if (projcontainerCustomFieldList.length > 0)
		projcontainerCustomFieldList = projcontainerCustomFieldList.substring(0, projcontainerCustomFieldList.length - 4);

	var userId = parseInt(jQuery('#projcontainer-user-1').val());

	PanteraScript.PanteraScriptService.UpdateProjectContainerAdmin(PJQ.app.session.id, jQuery('#projcontainer-name').val(), jQuery('#projcontainer-address1').val(), jQuery('#projcontainer-address2').val(), jQuery('#projcontainer-city').val(), stateProvince, jQuery('#projcontainer-zip').val(), jQuery('#projcontainer-country').val(), jQuery('#projcontainer-notes').val(), projcontainerCustomFieldList, userId, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', UpdateProjContainerC, onScriptError);

	return true;
}

function UpdateProjContainerC(response) {
	DisableSave();
	if (PJQ.app.module === PJQ.constants.modules.APP) {
		PJQ.notifications.notify.successNotify({
			message: 'Mall details saved'
		});
	}
	else {
		if (typeof pjqIsNewProject !== 'undefined' && pjqIsNewProject) {
			var url = window.location.href.replace('projectid=0', 'projectid=' + response);
			url += '&nps=1';
			window.location.href = url;
		}
		else if (typeof pjqIsNewProjContainer !== 'undefined' && pjqIsNewProjContainer) {
			var url = window.location.href.replace('projcontainerid=0', 'projcontainerid=' + response);
			url += '&npc=1';
			window.location.href = url;
		}
		else {
			if (0 == jQuery('#tabsMain').tabs('option', 'active'))
				showLeftSideInfo('Project saved.');
			else
				showLeftSideInfo(settings.ProjContainerLabel + ' saved.');
		}
	}
}

function ContactInfoCFClick(ev, sender) {
	var cell = jQuery(sender).parent();
	cell.trigger({type: 'click', button: 2});
}

function ContactInfoCFContext(ev, sender) {
	var cell = jQuery(sender).parent();
	cell.trigger({type: 'click', button: 0});
	cell.trigger({type: 'mousedown', button: 2, pageX: ev.pageX, pageY: ev.pageY}).trigger({
		type: 'mouseup',
		pageX: ev.pageX,
		pageY: ev.pageY
	});

}

function eXcell_contactinfocf(cell) { // contact info
	if (cell) {                                                     //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}                                //read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	}      // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var parts = val.split("|||");
		var title = parts[0];
		if (!title)
			title = parts[6];

		var rowCount = 6;
		if (parts[4])
			rowCount++;
		if (parts[5])
			rowCount++;
		if (parts[6])
			rowCount++;
		if (parts[7])
			rowCount++;
		if (parts[8])
			rowCount++;

		if (parts.length > 16)
			rowCount += (parts.length - 16) / 2;

		var icons = '&nbsp;';
		var iconsClass = 'ci-icon-hidden';

		var template = "<table border='0' class='contact-info-table' style='margin-top: 2px; margin-bottom: 4px;' onclick='ContactInfoCFClick(event, this);' oncontextmenu='ContactInfoCFContext(event,this);'>";
		template = template + "<tr><td class='" + iconsClass + "' nowrap='nowrap' valign='top' rowspan='" + rowCount.toString() + "'>" + icons + "</td><td class='company-name' colspan='2'>" + parts[0] + "</td></tr>";
		if (parts[2])
			template = template + "<tr><td colspan='2'>" + parts[1] + " (" + parts[2] + ")</td></tr>";
		else
			template = template + "<tr><td colspan='2'>" + parts[1] + "</td></tr>";

		template = template + "<tr><td class='pjq-field-label'>Phone:</td><td >" + parts[3] + "</td></tr>";
		if (parts[6])
			template = template + "<tr><td class='pjq-field-label'>Email</td><td class='company-email'><a href='mailto:" + parts[6] + "'>" + parts[6] + "</a></td></tr>";
		if (parts.length > 13) {
			var ii = 0;
			for (ii = 17; ii < parts.length; ii += 2)
				template = template + "<tr><td class='pjq-field-label'>" + parts[ii] + ":</td><td >" + parts[ii + 1] + "</td></tr>";
		}
		template = template + "<tr><td colspan='2' class='show-details'><a href='javascript:void(0)' onclick='ShowDetails(this); event.preventDefault();'>Show More...</a></td></tr>";

		if (parts[4])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Fax</td><td class='pjq-hidden hideable'>" + parts[4] + "</td></tr>";
		if (parts[5])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Cell</td><td class='pjq-hidden hideable'>" + parts[5] + "</td></tr>";
		if (parts[7])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Address 1</td><td class='pjq-hidden hideable'>" + parts[7] + "</td></tr>";
		if (parts[8])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Address 2</td><td class='pjq-hidden hideable'>" + parts[8] + "</td></tr>";

		var location = parts[9];
		if (parts[10]) {
			if (location)
				location = location + ', ';

			location = location + parts[10];
		}
		if (parts[11]) {
			if (location)
				location = location + ' ';

			location = location + parts[11];
		}
		if (parts[12]) {
			if (location)
				location = location + ' ';

			location = location + parts[12];
		}
		if (location)
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>City, State, Zip</td><td class='pjq-hidden hideable'>" + location + "</td></tr>";

		template = template + "<tr><td colspan='2' class='hide-details pjq-hidden'><a href='javascript:void(0)' onclick='HideDetails(this); event.preventDefault();'>Show Less...</a></td></tr>";
		template = template + "</table>";
		this.setCValue(template);
	}
}

eXcell_contactinfocf.prototype = new eXcell;    // nest all other methods from base class
eXcell_contactinfocf.prototype.getTitle = function () {

	var tip = jQuery("td.company-name", jQuery(this.cell)).text();
	if (!tip)
		tip = jQuery("td.company-email", jQuery(this.cell)).text();

	if (tip)
		return tip;

	return this.cell.innerHTML;
}